@import "../../../../../styles/variables.scss";

.facet {
  border: 1px solid white;
  box-sizing: border-box;
  margin-right: 0;
  margin-bottom: 20px;

  &-horizontal {
    width: 278px;
    height: 48px;
    border: 1px solid #e6e6e6;
    background-color: #ffffff;
  }

  @media (min-width: $uiaas-tablet) {
    margin: 0px 20px 20px 4px;
  }
  &__checkbox {
    display: flex;
    padding: 4px 0 8px 0;
    font-size: 14px;
    font-weight: normal;
    color: var(--se-black);
  }

  &__title {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
    margin: 16px 6px 15px 0;

    &:first-letter {
      text-transform: uppercase;
    }
  }

  &__header {
    text-decoration: none;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-bottom: none;
    justify-content: space-between;
    cursor: pointer;
    &-horizontal {
      text-decoration: none;
      display: flex;
      align-items: center;
      padding: 0 20px;
      justify-content: space-between;
      border: none;
    }
  }

  &__header-link {
    color: #333333 !important;
    text-decoration: none;
  }

  &__show-header {
    border-top: none !important;
  }

  &__accordion {
    transition: all 0.4s ease-in-out;
    &--open {
      opacity: 1;
      height: auto;
    }

    &--close {
      height: 0px;
      opacity: 0;
    }
  }

  &__body {
    background-color: #ffffff;
    transition: all 0.2s ease-in-out;
    overflow: hidden;
    padding: 16px;
    z-index: 1;
    flex-direction: column;
    &--open {
      opacity: 1;
      height: auto;
      border-top: 1px solid var(--se-divider, #e6e6e6);
      &-horizontal {
        position: relative;
        background-color: #ffffff;
        box-shadow: 0px 7px 18px -7px rgba(51, 51, 51, 0.18);
      }
    }

    &--close {
      height: 0px;
      opacity: 0;
      padding: 0px 20px;
      &-horizontal {
        height: 0px;
        padding: 0px 20px;
      }
    }
  }

  &__body-single-option {
    @extend .facet__body;
    padding: 0px;
    padding-top: 16px;
    padding-bottom: 16px;
    border-top: 1px solid var(--se-divider, #e6e6e6);
    &--open {
      @extend .facet__body--open;
    }

    &--close {
      height: 0px;
      opacity: 0;
      padding: 0px 20px;
    }
  }

  &__arrow {
    height: 8px;
    width: 8px;
    transform: rotate(-225deg);
    border-top: 1px solid;
    border-right: 1px solid rgb(51, 51, 51);
    transition: 0.2s;
    margin-bottom: 2px;

    &--rotated {
      @extend .facet__arrow;
      transform: rotate(-45deg);
      transform-origin: 100% 50%;
      margin-bottom: 0px;
    }
  }
}

.search_facet_title {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
}

.product-catalog-tooltip {
  display: block;
  direction: ltr;
  position: relative;

  .product-catalog-tooltip-content {
    color: var(--se-alternative-contrast, #333333);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    visibility: hidden;
    z-index: 0;
    left: auto;
    right: auto;
    top: -70px;
    opacity: 0;
    transition:
      visibility 0.3s ease-in-out,
      opacity 0.3s ease-in-out;
    background-color: white;
    padding: 8px;
    position: absolute;
    width: 190px;
    border-radius: 3px;
    box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.38);

    &::after {
      content: "";
      position: absolute;
      top: 56px;
      right: 50%;
      border-width: 8px;
      border-style: solid;
      border-color: white transparent transparent transparent;
    }
  }

  &:hover .range-tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}

.characteristic_label {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  margin: 20px 6px 20px 0;
}

.characteristic-wrapper {
  margin: 0px 20px 20px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
